const logoDefaultUrl = require('@/assets/images/logo-main-full-white.png');
const logoGreenUrl = require('@/assets/images/logo-main-full-white.png');

const logoEccoviaDefaultUrl = require('@/assets/images/logo-eccovia-black-full.png');
const logoEccoviaWhiteUrl = require('@/assets/images/logo-eccovia-full-white.png');

const logoLlaDefaultUrl = require('@/assets/images/logo-lla-full-white.png');
const logoLlaWhiteUrl = require('@/assets/images/logo-lla-full-white.png');

const cartCreditDefaultUrl = require('../assets/images/icon-credit-card@3x.png');
const cartCreditGreenUrl = require('../assets/images/icon-credit-card@3x.png');

const cartClientDefaultUrl = require('../assets/images/icon-client-card@3x.png');
const cartClientGreenUrl = require('../assets/images/icon-client-card@3x.png');

const outdoorPaymentApp = require('../assets/images/icon-payment-app.png'); // icon-payment-app.png
const outdoorPaymentSms = require('../assets/images/icon-payment-sms.png'); // icon-payment-sms.png
const outdoorPaymentCreditCard = require('../assets/images/icon-payment-creditcard.png'); // icon-payment-creditcard.png
const outdoorPaymentNfc = require('../assets/images/icon-payment-nfc.png'); // icon-payment-nfc.png
const outdoorPaymentNfcOrange = require('../assets/images/icon-payment-nfc-orange.png'); // icon-payment-nfc.png

export default {
  iLogo: {
    defaultUrl: logoDefaultUrl,
    greenUrl: logoGreenUrl,
  },
  iLlaLogo: {
    defaultUrl: logoLlaDefaultUrl,
    whiteUrl: logoLlaWhiteUrl,
  },
  iEccoviaLogo: {
    defaultUrl: logoEccoviaDefaultUrl,
    whiteUrl: logoEccoviaWhiteUrl,
  },
  iCartCredit: {
    defaultUrl: cartCreditDefaultUrl,
    greenUrl: cartCreditGreenUrl,
  },
  iCartClient: {
    defaultUrl: cartClientDefaultUrl,
    greenUrl: cartClientGreenUrl,
  },
  iPaymentApp: {
    defaultUrl: outdoorPaymentApp,
  },
  iPaymentSms: {
    defaultUrl: outdoorPaymentSms,
  },
  iPaymentCC: {
    defaultUrl: outdoorPaymentCreditCard,
  },
  iPaymentNfc: {
    defaultUrl: outdoorPaymentNfc,
    orangeUrl: outdoorPaymentNfcOrange,
  },
};
